<template>
    <div class="static">
        <router-view class="animated" />

        <TheFooter class="footer-base" />

        <vue-snotify />
    </div>
</template>

<script>
import TheFooter from '@/components/TheFooter'

export default {
    components: {
        TheFooter
    },
    data() {
        return {}
    },
    computed: {
    },
    beforeCreate() {
        document.documentElement.classList.remove('auth-layout')
        document.body.classList.remove('auth-layout')
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.static {
    background-color: #fff;
}
</style>
